import { useEffect, useState } from 'react';
import styles from './MainPage.module.css';
import { getBoxes } from '../../Requests/boxes/boxes';
import type { Collection } from '../../types/Boxes/boxes';
import Reward from '../../components/Reward/Reward';
import BoxModal from './BoxModal';
import { useModalStore } from '../../store/ModalStore';
import BluePage from '../../components/BluePage/BluePage';
import { useBluePageStore } from '../../store/BluePageStore';
import Loader from '../../components/Loader/Loader';
import Carousel from './Carousel';
import UserInfoTop from '../../components/UserInfoTop/UserInfoTop';
import SlotsContainer from './Slots/SlotsContainer';
import type { WebApp } from '../../types/telegram';
import BalanceTop from '../../components/BalanceTop/BalanceTop';

interface ExtendedWebApp extends WebApp {
  contentSafeAreaInset?: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
}

const MainPage = () => {
  const [collection, setCollection] = useState<Collection[]>([]);
  const [chosenId, setChosenId] = useState<number>();
  const open = useBluePageStore((state) => state.open);
  const setOpen = useModalStore((state) => state.setOpen);
  const [banners, setBanners] = useState([]);

  const [loading, setLoading] = useState<boolean>(true);
  const [showLoader, setShowLoader] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState<boolean>(false);


  // Функция для проверки загрузки всех изображений
  const checkImagesLoaded = (
    banners: { image?: string }[],
    collections: Collection[],
  ) => {
    const allImages: string[] = [];

    // Собираем все URL изображений из баннеров
    banners.forEach((banner) => {
      if (banner.image) allImages.push(banner.image);
    });

    // Собираем все URL изображений из коллекций
    collections.forEach((collection) => {
      collection.boxes.forEach((box) => {
        if (box.background) allImages.push(box.background);
        if (box.box_image) allImages.push(box.box_image);
      });
    });

    if (allImages.length === 0) {
      setImagesLoaded(true);
      return;
    }

    let loadedCount = 0;
    const totalImages = allImages.length;

    allImages.forEach((imageUrl) => {
      const img = new Image();
      img.onload = () => {
        loadedCount++;
        if (loadedCount === totalImages) {
          setImagesLoaded(true);
        }
      };
      img.onerror = () => {
        loadedCount++;
        if (loadedCount === totalImages) {
          setImagesLoaded(true);
        }
      };
      img.src = imageUrl;
    });
  };

  useEffect(() => {
    const getBoxesRequest = async () => {
      try {
        // const response = await getBoxes();
        // setCollection(response.collections);
        // setBanners(response.banners);
        // console.log(response, 'boxes');

        // // Проверяем загрузку изображений после получения данных
        // checkImagesLoaded(response.banners, response.collections);
      } catch (e) {
        console.error('Failed to load boxes', e);
      } finally {
        setLoading(false);
      }
    };
    getBoxesRequest();
  }, []);

  // Показываем лоадер пока загружаются данные или изображения
  // useEffect(() => {
  //   if (loading || !imagesLoaded) {
  //     const timer = setTimeout(() => {
  //       setShowLoader(true);
  //     }, 1000);
  //     return () => clearTimeout(timer);
  //   } else {
  //     setShowLoader(false);
  //   }
  // }, [loading, imagesLoaded]);

  const openModal = (id: number) => {
    setChosenId(id);
    setOpen(true);
  };

  if ((loading || !imagesLoaded) && showLoader) {
    return (
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
    );
  }

  useEffect(() => {
      const tg = window.Telegram?.WebApp as ExtendedWebApp;
      if (!tg) return;
  
      console.log(window.Telegram?.WebApp.initData);
  
      const apply = () => {
        const top = tg?.contentSafeAreaInset?.top ?? 0;
        document.documentElement.style.setProperty(
          '--tg-viewport-content-safe-area-inset-top',
          `${top}px`,
        );
      };
  
      apply();
      tg.onEvent?.('contentSafeAreaChanged', apply);
      return () => tg.offEvent?.('contentSafeAreaChanged', apply);
    }, []);

  return (
    <div className={styles.pageContainer}>
      <BalanceTop />
      <div className={styles.content}>
        <UserInfoTop />
        <SlotsContainer />
      </div>
    </div>
  );
};

export default MainPage;
